export const NEUTRAL = 0
export const DELETE = 1
